export const PAGE_FORMATTING_BASE =
  "mx-12 md:mx-[12%] my-6 pb-32 font-fam-sarabun text-xl";

export const ALL_BUS_CATEGORIES_OPTIONS = {
  "General Private Buses (Kolkata and Howrah)": [
    {
      value: "Private Buses (Kolkata & Howrah) (Below 100)",
      label: "Below 100",
      description: "General private buses with numbering under 100.",
    },
    {
      value: "Private Buses (Kolkata & Howrah) (200 Bus series)",
      label: "200 Bus series",
      description: "General private buses with numbering above 200.",
    },
    {
      value: "Minibuses (Kolkata & Howrah)",
      label: "Minibuses",
      description: "Minibus routes in the city and surroundings.",
    },
    {
      value: "JM, K, KB and AS Series Buses",
      label: "JM, K, KB and AS Series Buses",
      description:
        "Specially numbered buses in the city and surroundings. While JM buses are bigger buses with more seating capacities; K, KB and AS series buses are usually sized.",
    },
  ],

  "District Series Buses (Kolkata and Howrah)": [
    {
      value: "Private Express Buses (Kolkata & Howrah) (Numbered)",
      label: "L and E series (Express)",
      description:
        "Private buses with L and E suffix, with all terminating at Howrah station.",
    },
    {
      value: "DN Series Buses",
      label: "DN Series Buses",
      description:
        "Private buses with DN suffix, mainly serving North suburbs of Kolkata and North 24 Pargana district.",
    },
    {
      value: "SD Series Buses",
      label: "SD Series Buses",
      description:
        "Private buses with SD suffix, mainly serving South suburbs of Kolkata and South 24 Pargana district.",
    },
    {
      value: "MM and MN Series Buses",
      label: "MM and MN Series Buses",
      description:
        "Private buses / minibuses with MM and MN suffix, mainly serving North 24 Pargana district.",
    },
  ],

  "Miscellaneous Private Buses (Kolkata and Howrah)": [
    {
      value: "Unnumbered Routes (RTA and STA)",
      label: "Unnumbered RTA Express and STA buses",
      description: "Unnumbered non AC buses with RTA and STA permits.",
    },
    {
      value: "Corporate and other AC Buses",
      label: "Corporate and other AC Buses",
      description: "Privately owned AC bus services.",
    },
  ],

  "General Private Buses (Other Districts)": [
    {
      value: "Hoogly General Private and Express Buses",
      label: "Hoogly buses",
      description: "General buses centered around Hoogly district.",
    },
    {
      value: "Nadia General Private Buses",
      label: "Nadia General buses",
      description: "General buses centered around Nadia district.",
    },
    {
      value: "Nadia Unnumbered Buses",
      label: "Nadia Unnumbered Private buses",
      description:
        "Buses with no number centered around Nadia district. Some of them may be express service.",
    },
  ],

  "Government Non AC Buses (Kolkata and Howrah)": [
    {
      value: "WBTC Buses S Series",
      label: "S Series",
      description:
        "Government buses with S suffix, the most visible government buses in the city.",
    },
    {
      value: "WBTC Buses E Series (Executive)",
      label: "E Series (Executive)",
      description:
        "Government buses with E suffix which represent executive bus services. These buses generally allow only seating passengers, and standing is not allowed.",
    },
    {
      value: "WBTC Buses C Series",
      label: "C Series",
      description:
        "Government buses with C suffix, representing city bus services.",
    },
    {
      value: "WBTC Buses D Series",
      label: "D Series",
      description:
        "Government buses with D suffix, representing district bus services.",
    },
    {
      value: "WBTC Buses E Series (Express)",
      label: "E Series (Express)",
      description:
        "Government buses with E suffix, representing express bus services. These serve long routes.",
    },
    {
      value: "WBTC Buses T Series",
      label: "T Series",
      description: "Government buses with T suffix.",
    },
    {
      value: "WBTC Buses ST Series",
      label: "ST Series",
      description:
        "Government buses with ST suffix. Some of there serve interiors of South 24 Parganas.",
    },
    {
      value: "WBTC Buses Unsuffixed routes",
      label: "Unsuffixed routes",
      description:
        "Government buses without any suffix. These are the oldest state bus routes in operations. Their services have reduced considerably.",
    },
    {
      value: "WBTC Buses M, MX and MIDI Series",
      label: "M, MX and MIDI Series",
      description:
        "Government buses with M, MX and MIDI suffixes. These generally represent minibus / midibus services",
    },
    {
      value: "WBTC Buses NB, DS Series and others",
      label: "NB, DS Series and others",
      description:
        "Government buses with NB, DS and other suffixes. These represent dedicated services for an area or special fare routes.",
    },
    {
      value: "WBTC Buses Unnumbered",
      label: "WBTC Buses Unnumbered",
      description:
        "Government buses without any route numbers. These are often shuttle or office special routes.",
    },
  ],

  "Government AC Buses (Kolkata and Howrah)": [
    {
      value: "WBTC AC Buses AC Series",
      label: "AC Series",
      description: "Government AC buses with AC suffix.",
    },
    {
      value: "WBTC AC Buses EB Series",
      label: "EB Series",
      description: "Government Electric AC buses with EB and EBX suffixes.",
    },
    {
      value: "WBTC AC Buses V, VS, ACST and ACS Series",
      label: "V, VS, ACST and ACS Series",
      description: "Government AC buses with V, VS, ACST and ACS suffixes.",
    },
    {
      value: "WBTC AC Buses ACT Series",
      label: "ACT Series",
      description:
        "Government AC buses with ACT suffix. Most of them provide long distance services.",
    },
  ],

  "Kolkata Trams": [
    {
      value: "WBTC Trams",
      label: "Kolkata Trams",
      description: "Anur.",
    },
  ],
};

export const categoryLinkForSubCategories = {
  "/general-private-buses-kolkata-howrah": [
    "Private Buses (Kolkata & Howrah) (Below 100)",
    "Private Buses (Kolkata & Howrah) (200 Bus series)",
    "Minibuses (Kolkata & Howrah)",
    "JM, K, KB and AS Series Buses",
    "Hoogly General Private Buses",
  ],
  "/district-series-buses-kolkata-howrah": [
    "Private Express Buses (Kolkata & Howrah) (Numbered)",
    "DN Series Buses",
    "SD Series Buses",
    "MM and MN Series Buses",
  ],
  "/miscellaneous-private-buses-kolkata-howrah": [
    "Unnumbered Routes (RTA and STA)",
    "Corporate and other AC Buses",
  ],
  "/general-private-buses-other-districts": [
    "Hoogly General Private and Express Buses",
    "Nadia General Private Buses",
    "Nadia Unnumbered Buses",
  ],
  "/government-non-ac-buses-kolkata-howrah": [
    "WBTC Buses S Series",
    "WBTC Buses C Series",
    "WBTC Buses D Series",
    "WBTC Buses E Series (Express)",
    "WBTC Buses T Series",
    "WBTC Buses ST Series",
    "WBTC Buses E, M, MX Series and Others",
    "WBTC Buses Unnumbered",
  ],
  "/government-ac-buses-kolkata-howrah": [
    "WBTC AC Buses V, VS and MW Series",
    "WBTC AC Buses AC Series",
    "WBTC AC Buses EB Series",
    "WBTC AC Buses ACT Series",
  ],
  "/kolkata-trams": ["WBTC Trams"],
};

export const EASY_NAVIGATION_TEXT = `To allow easier navigation, the route lists have been divided into separate categories. In the select box, you can select a category to get bus routes under that category. Also, don't forget to utilize the browser's search features if you feel the list difficult to navigate. AND YES, Click on the route number / name to get more details about that route.`;

export const DIR_VALUES = { U: "UP", D: "DWN" };
export const AV_VALUES = { V: "Visible", R: "Rare", T: "Fixed Time" };
